<template>
  <div class="developer-score">
    <v-chip
      :color="scoreColor"
      text-color="white"
      small
      class="developer-score__chip"
    >
      {{ score }}%
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    score: {
      type: Number,
      required: true,
    },
  },

  computed: {
    scoreColor() {
      let color = 'green';
      if (this.score < 40) {
        color = 'red';
      } else if (this.score < 70) {
        color = 'yellow';
      }
      return color;
    },
  },
};
</script>

<style lang="scss" scoped>
.developer-score__chip {
  border-radius: 16px;
  height: 22px;
  min-width: 54px;
  display: inline-block;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
}
</style>
